<!-- Quantity Stepper for qscV2. -->
<ng-template #qscV2>
    <!-- Stepper Buttons -->
    <div *ngIf="!updateState.show && this.calledBy !== 'editpastpurchases' && product.price > 0"
        id="addButton_{{product.id}}" class="btn product-btn__qty-step justify-content-center"
        [ngClass]="{'product-btn--signin': !isAuthorized}" role="group" (click)="onQscStepperClick()" (keydown.enter)="onQscStepperClick()"
        attr.data-qty-id="pc{{product.id}}Inpt" tabindex="0"
        [attr.aria-label]="isAuthorized ? ADD + ' 1 unit of ' + getProductFullName() : SIGNIN + ' 1 unit of ' + getProductFullName()"
        data-qa="addbutton">
        <!-- Decrease Button -->
        <button *ngIf="isQuantityStepperExtended" class="product-btn__qty-step__decrease"
            [disabled]="showQtyUpdateBtn || updateState.input > product.inventoryQty" id="dec_qtyInfo_{{product.id}}"
            (click)="qscDecrease()" role="button" tabindex="0" attr.aria-label="Decrease Quantity {{getProductFullName()}}"
            data-qa="prdctdcrmntr">
            <span aria-hidden="true" class="svg-qty-stepper-decrease product-btn__qty-step__decrease--icon"></span>
        </button>
        <span class="product-btn__qty-step__amt" id="qtyInfo_{{product.id}}" role="button" (click) = "onQscAmtClick()" (keydown.enter) = "onQscAmtClick()"
            attr.aria-label="{{quantityAriaLabelMessage}}" tabindex="0" data-qa="qty-stppr-qtymsg"> {{ qscQuantity }} </span>
        <!-- Increase Button -->
        <button *ngIf="isQuantityStepperExtended" class="product-btn__qty-step__increase"
            [ngClass]="{'product-btn__qty-step__increase': true, 'product-btn__qty-step__increase--max-amt qsc-step__increase--max-amt':qscQuantity >= product.inventoryQty || qscQuantity >= product.maxPurchaseQty }"
            id="inc_qtyInfo_{{product.id}}" (click)="qscIncrease()" role="button" tabindex="0"
            attr.aria-label="Increase Quantity {{getProductFullName()}}"
            attr.aria-disabled="{{product.quantity >= product.inventoryQty || product.quantity >= product.maxPurchaseQty ? 'true' : 'false' }}"
            data-qa="prdctincrmntr">
            <span aria-hidden="true" class="svg-qty-stepper-increase product-btn__qty-step__increase--icon"></span>
        </button>
    </div>
    <!-- Update Button -->
    <div *ngIf="updateState.show" class="btn product-btn__update">
        <!-- Input Box -->
        <input onclick="this.select()" class="product-btn__update__input-box" id="qtyInfoControl_{{product.id}}"
            aria-label="Cart Quantity" attr.aria-describedby="{{carouselId}}pg{{product.id}}"
            (keydown.enter)="qscEnterTabKeyDown()" (keydown)="inputKeydown($event)" (keyup)="inputKeyup($event)"
            [(ngModel)]="updateState.input" type="number" min="0" max="{{product.maxPurchaseQty}}" step="1"
            data-qa="prd-qty-stppr-qtybox" />

        <!-- Update Btn -->
        <button class="btn product-btn__update__input-btn"
            [disabled]="showQtyUpdateBtn || updateState.input > product.inventoryQty" (click)="qscUpdateAmt()"
            attr.aria-describedby="{{carouselId}}pg{{product.id}}" data-qa="prdqtyupdate" tabindex="0">
            {{updateState.button}}
        </button>
    </div>
</ng-template>

<div class="quantity-stepper-v3" [ngClass]="{'qsc-step-default' : isQscV2, 'qsc-step' : isQuantityStepperExtended && isQscV2, 'qsc-step-disabled' : !_isCheckboxChecked && isQscV2}" *ngIf="this.calledBy !== 'minicart' && !isBiaAddAll">
    <div class="quantity-stepper-container">
       <ng-container *ngIf="!isQscV2; else qscV2">
            <div [ngClass]="{
                'product-btn': true,
                'product-btn--with-addl-info': (!isMarketPlaceEnabled && isAnyProductHasAddlInfo) && !isLightWeightProduct,
                'product-btn--without-ar': !isAnyProductHasAddlInfo  && !isLightWeightProduct,
                'full-loading': calledBy !== 'snsCheckoutFlowModal' && (product.quantity === 0 || updateState.show),
                'remove-loading': this.calledBy === 'editpastpurchases',
                'add-product-checkmark': checkMark,
                'product-btn--light': isLightWeightProduct
            }"
             (keyup)="qtyStepperKeyup($event)">
                <span aria-live="assertive" aria-atomic="true" class="sr-only">{{stepperAnnouncement}}</span>
                <!-- Add Button -->
                <div *ngIf=" calledBy !== 'snsCheckoutFlowModal' && (product.quantity === null || (product.quantity === 0) && !updateState.show && this.calledBy !== 'editpastpurchases' && product.price > 0) "
                    id="addButton_{{product.id}}" class="btn product-btn__add" [ngClass]="{'product-btn--signin': !isAuthorized,  'd-flex align-items-center justify-content-center': isLightWeightProduct}"
                        role="button" (click)="addToCart()"
                    attr.data-qty-id="pc{{product.id}}Inpt" tabindex="0"
                        [attr.aria-label]="isAuthorized ? ((isOnProductDetail && changeLabel) ? changeLabel : ADD) + ' 1 unit of ' + getProductFullName() : SIGNIN + ' 1 unit of ' + getProductFullName()"
                    data-qa="addbutton">
                        {{ isAuthorized ? ((isOnProductDetail && changeLabel) ? changeLabel : ADD):  isLightWeightProduct ? SIGNIN_LIGHT : SIGNIN }}
                </div>

                <!-- Stepper Buttons -->
                <div *ngIf="calledBy === 'snsCheckoutFlowModal' || (product.quantity > 0 && !updateState.show && this.calledBy !== 'editpastpurchases')"
                    [ngClass]="{'btn':true, 'product-btn__qty-step': true, 'product-btn__qty-step--loading':loadingSpinner}"
                    role="group" attr.aria-describedby="{{carouselId}}pg{{product.id}}">

                    <!-- Decrease Button -->
                    <button class="product-btn__qty-step__decrease"
                                [ngClass]="{'product-btn__qty-step__decrease--min-amt': calledBy === 'snsCheckoutFlowModal' && qscQuantity <= 1}"
                            [disabled]="(showQtyUpdateBtn || updateState.input > product.inventoryQty && calledBy !== 'snsCheckoutFlowModal') || (calledBy === 'snsCheckoutFlowModal' && qscQuantity <= 1)"
                        id="dec_qtyInfo_{{product.id}}" (click)="decreaseCart()" role="button" tabindex="0"
                        attr.aria-label="Decrease Quantity {{getProductFullName()}}"
                        data-qa="prdctdcrmntr">
                            <span aria-hidden="true" class="svg-qty-stepper-decrease product-btn__qty-step__decrease--icon"></span>
                    </button>
                    <!-- Current Quantity info -->
                    <span class="sr-only"></span>
                    <span class="product-btn__qty-step__amt"
                            id="qtyInfo_{{product.id}}" (click)="calledBy !== 'snsCheckoutFlowModal' && showUpdate()" role="button"
                        attr.aria-label="{{quantityAriaLabelMessage}}" tabindex="0"
                        data-qa="qty-stppr-qtymsg">{{quantityMessage}}</span>
                    <!-- Increase Button -->
                        <button class="product-btn__qty-step__increase" [ngClass]="{'product-btn__qty-step__increase': true, 'product-btn__qty-step__increase--max-amt':product.quantity >= product.inventoryQty || (product.quantity >= product.maxPurchaseQty && calledBy !== 'snsCheckoutFlowModal') || (calledBy === 'snsCheckoutFlowModal' && qscQuantity >= product.maxPurchaseQty)}"
                        id="inc_qtyInfo_{{product.id}}" (click)="beforeIncreaseCart(false)" role="button" tabindex="0"
                        attr.aria-label="Increase Quantity {{getProductFullName()}}" attr.aria-disabled="{{product.quantity >= product.inventoryQty || product.quantity >= product.maxPurchaseQty ? 'true' : 'false' }}"
                        data-qa="prdctincrmntr">
                        <span aria-hidden="true" class="svg-qty-stepper-increase product-btn__qty-step__increase--icon"></span>
                    </button>
                </div>

                <!-- Update Button -->
                <div *ngIf="updateState.show && calledBy !== 'snsCheckoutFlowModal'" class="btn product-btn__update">
                    <!-- Input Box -->
                    <input onclick="this.select()" class="product-btn__update__input-box" id="qtyInfoControl_{{product.id}}" aria-label="Cart Quantity"
                            attr.aria-describedby="{{carouselId}}pg{{product.id}}" (keydown.enter)="enterTabKeyDown($event)"
                            (keydown)="inputKeydown($event)" (keyup)="inputKeyup($event)" [(ngModel)]="updateState.input" type="number" min="1"
                            max="{{product.maxPurchaseQty}}" step="1" data-qa="prd-qty-stppr-qtybox"/>
                        
                    <!-- Update Btn -->
                    <button class="btn product-btn__update__input-btn" [disabled]="showQtyUpdateBtn || updateState.input > product.inventoryQty" 
                                (click)="updateCart()" attr.aria-describedby="{{carouselId}}pg{{product.id}}" data-qa="prdqtyupdate">
                            {{updateState.button}}
                    </button>
                </div>
        </div>
        </ng-container>
    </div>
</div>

<!-- MTO Pop up -->
<ng-container *ngIf="mto.popup.show">
    <div class="mto-popup p-{{product.id}} modal fade" id="mtoModal" tabindex="-1" role="dialog"
        aria-labelledby="mtoModalLabel" aria-hidden="true">
        <div class="mto-popup__dialog modal-dialog" role="document">
            <div class="mto-popup__content modal-content">
                <div class="mto-popup__body modal-body" data-qa="mto">
                    <button class="mto-popup__close-btn close" type="button" data-dismiss="modal" aria-label="Close" data-qa="mto-close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
                            <path fill="#4B4B4B" fill-rule="evenodd"
                                d="M18.493 2.623L17.3 1.46 9.872 9.074 2.627 1.467 1.42 2.617l7.287 7.65-7.28 7.462 1.193 1.164 7.237-7.418 7.058 7.411 1.207-1.15-7.1-7.455 7.471-7.658z"
                                clip-rule="evenodd" />
                        </svg>
                    </button>
                    <p class="mto-popup__title" id="mtoModalLabel" data-qa="mto-ttl">{{ reservedTimeIntent | titlecase }} time will change</p>
                    <p class="mto-popup__text" data-qa="mto-txt">This item requires {{ getMtoPopupText() }} to prepare. Please
                        select a new time for {{ reservedTimeIntent }}</p>
                    <button type="button" class="mto-popup__reserve-btn btn btn-default"
                        (click)="reserveNewTime();analyticsMTOClicks('reserve-new-time')" data-qa="mto-rsrv-btn">Reserve new time</button>
                    <button type="button" class="mto-popup__choose-time-btn btn btn-default btn-secondary"
                        (click)="chooseTimeLater();analyticsMTOClicks('choose-time-later')" data-qa="mto-chs-tm-btn">Choose time later</button>
                    <button type="button" class="mto-popup__dont-add-btn btn btn-link" data-dismiss="modal"
                        (click)="analyticsMTOClicks('dont-add-item')" data-qa="mto-dnt-add-btn">Don't add item</button>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- MTO Error Modal -->
<ng-container *ngIf="mto.error.show">
    <div class="mto-popup-error p-{{product.id}} modal fade" id="mtoModalError" tabindex="-1" aria-label="Item can't be added to cart" aria-hidden="true" role="dialog">
        <div class="mto-popup-error__dialog modal-dialog" role="document">
            <div class="mto-popup-error__content modal-content">
                <div class="mto-popup-error__body modal-body" data-qa="mto-err">
                    <div class="mto-popup-error__text-container">
                        <button class="mto-popup-error__close-btn close" data-dismiss="modal" aria-label="Close" data-qa="mto-err-close">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mto-popup-error__close-svg" fill="none" viewBox="0 0 20 20">
                                <path fill="#4B4B4B" fill-rule="evenodd" d="M18.493 2.623L17.3 1.46 9.872 9.074 2.627 1.467 1.42 2.617l7.287 7.65-7.28 7.462 1.193 1.164 7.237-7.418 7.058 7.411 1.207-1.15-7.1-7.455 7.471-7.658z" clip-rule="evenodd" />
                            </svg>
                        </button>
                        <div class="mto-popup-error__paragraphs">
                            <p class="mto-popup-error__title" data-qa="mto-err-ttl">
                                <span class="mto-popup-error__icon-exclamation" aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="#DD1E25"
                                        class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                                        <path
                                            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z">
                                        </path>
                                    </svg>
                                </span>
                                Item can't be added to cart
                            </p>
                            <p class="mto-popup-error__text" data-qa="mto-err-txt">Made to order items require {{ getMtoPopupText() }} to prepare and won’t be ready in time for {{ reservedTimeIntent }}.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
